import { render, staticRenderFns } from "./ChangeKennelOwnerSignatures.vue?vue&type=template&id=1588bcfa"
import script from "./ChangeKennelOwnerSignatures.vue?vue&type=script&lang=ts"
export * from "./ChangeKennelOwnerSignatures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports